import React, { useState } from 'react';
import { doc, deleteDoc } from 'firebase/firestore';
import { db, auth } from '../Firebase/Firebase';
import NewsForm from './NewsForm';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const NewsItem = ({ newsItem }) => {
    const { id, username, title, content, imageUrl, timestamp } = newsItem;
    const [isEditing, setIsEditing] = useState(false);

    const user = auth.currentUser;

    const handleDelete = async () => {
        try {
            const newsRef = doc(db, 'news', id);
            await deleteDoc(newsRef);
                        toast.success("Noticia eliminada exitosamente");
            
        } catch (error) {
            console.error("Error deleting document: ", error);
        }
    };

    return (

        <div>
            <ToastContainer />

            <div className='card-news'>
                <h3>{title}</h3>
                <p>{content}</p>
                {imageUrl && <img src={imageUrl} alt="News" />}
                <p>Por: {username}</p>
                <p>Fecha: {timestamp.toDate().toLocaleDateString('es-ES')} Time: {timestamp.toDate().toLocaleTimeString('es-ES')}</p>
                {user && user.displayName === username && (
                    <div className='card-button'>
                        <button onClick={() => setIsEditing(true)}>Editar</button>
                        <button onClick={handleDelete}>Borrar</button>
                    </div>
                )}
            </div>
            <NewsForm
                isOpen={isEditing}
                onRequestClose={() => setIsEditing(false)}
                newsItem={newsItem}
            />
        </div>
    );
};

export default NewsItem;
